import React from "react";
import { Navigate } from "react-router-dom";
import { ROUTE_PATHS } from "./paths";

type GuardProps = {
  isAllowed: boolean;
  redirectTo: string;
  children: React.ReactElement;
};

export const RouteGuard = ({ isAllowed, redirectTo, children }: GuardProps) => {
  if (!isAllowed) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export const PublicOnlyRoute = ({
  isAuthenticated,
  children,
}: {
  isAuthenticated: boolean;
  children: React.ReactElement;
}) => (
  <RouteGuard
    isAllowed={!isAuthenticated}
    redirectTo={ROUTE_PATHS.DASHBOARD}
  >
    {children}
  </RouteGuard>
);

export const ProtectedRoute = ({
  isAuthenticated,
  children,
}: {
  isAuthenticated: boolean;
  children: React.ReactElement;
}) => (
  <RouteGuard
    isAllowed={isAuthenticated}
    redirectTo={ROUTE_PATHS.CONNECT}
  >
    {children}
  </RouteGuard>
);
